<template>
  <el-breadcrumb
    separator-class="el-icon-arrow-right"
    class="def-w layout-breadcrumb f-ac"
  >
    <el-breadcrumb-item
      v-for="menu in breadcrumbList"
      :key="menu.id"
      :to="getRoute(menu)"
    >
      <div v-if="menu.isQuery" class="search-item">
        {{ menu.name }}
        <i class="el-icon-close" />
      </div>
      <template v-else>
        {{ menu.name }}
      </template>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LayoutBreadcrumb",
  components: {},
  props: {},
  data() {
    return {};
  },

  computed: {
    ...mapGetters(["activeMenu", "allMenusList", "curDetailTitle"]),
    breadcrumbList() {
      const homeMenu = this.allMenusList.find((m) => m.code === "home");
      const breadcrumbArr = [homeMenu, this.activeMenu];
      this.$route.path.includes("/detail") &&
        breadcrumbArr.push({
          name: this.curDetailTitle,
        });
      this.$route.query.title &&
        breadcrumbArr.push({
          name: this.$route.query.title,
          isQuery: true,
        });
      return this.uniqBy(breadcrumbArr, "id");
    },
  },

  created() {},

  mounted() {},

  methods: {
    uniqBy(arr, keyFn) {
      const seen = new Set();
      return arr.filter((obj) => {
        const k = typeof keyFn === "function" ? keyFn(obj) : obj[keyFn];
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
      });
    },
    isLastItem(menu) {
      const index = this.breadcrumbList.findIndex((b) => b.id === menu.id);
      return index === this.breadcrumbList.length - 1 || index === -1;
    },
    getRoute(menu) {
      // 如果是最后一项且不是查询项，不返回路由
      if (this.isLastItem(menu) && !menu.isQuery) {
        return null;
      }

      // 点击帮助中心或关于我们时，直接跳转到第一个子菜单
      if (menu.code === "bzzx" || menu.code === "gywm") {
        // 获取所有菜单树
        const allMenusTree = this.$store.state.permission.allMenusTree;
        // 找到当前菜单
        const currentMenu = allMenusTree.find((m) => m.code === menu.code);
        if (
          currentMenu &&
          currentMenu.children &&
          currentMenu.children.length > 0
        ) {
          // 返回第一个子菜单的路由
          const firstChild = currentMenu.children[0];
          return {
            path: firstChild.path,
            params: firstChild.params,
            query: { ...firstChild.query, t: Date.now() },
          };
        }
      }

      // 默认路由
      return {
        path: menu.path,
        params: menu.params,
        query: { ...menu.query, t: Date.now() },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.layout-breadcrumb {
  height: 20px;
  margin: 15px auto !important;

  .search-item {
    cursor: pointer;
    color: #0a569c;
    border: 1px solid #0a569c;
    border-radius: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 18px;
    position: relative;
    font-weight: normal;

    .el-icon-close {
      font-size: 12px;
      color: #999;
    }

    &:hover {
      border: 1px solid $--color-primary;

      .el-icon-close {
        color: $--color-primary;
      }
    }
  }
}
</style>
